module.exports = __webpack_public_path__ + "media/1_11.75fdee08.wav";